import { useVariantCopy } from "./useVariantCopy";
import { mainUrl } from "../../utils/variant";

// Variant landing-page footer (startviralgpt.com). Clone of components/Footer.js
// with route links (pricing, terms, privacy, refund) pointed at the main site
// via mainUrl().
const Footer = () => {
  const L = useVariantCopy();
  return (
    <div>
      {/* Platform Showcase */}
      <div className="stripe-section" style={{background: 'linear-gradient(180deg, #ffffff 0%, #f6f9fc 100%)'}}>
        <div className="stripe-container px-4 text-center">
          <h2 className="stripe-heading stripe-heading--md text-instagram mb-6">{L.footer.platformHeading}</h2>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-3">
            {[
              { icon: 'fa-instagram', color: 'text-instagram' },
              { icon: 'fa-tiktok', color: 'stripe-text-dark' },
              { icon: 'fa-youtube', color: 'text-red-600' },
              { icon: 'fa-twitter-x', color: 'stripe-text-dark' },
            ].map((p, i) => (
              <div key={i} className="flex flex-col items-center p-4">
                <i className={`fa-brands ${p.icon} ${p.color} mb-3`} style={{fontSize: '2.25rem'}}></i>
                <span className="stripe-body stripe-body--sm stripe-text-dark font-semibold">{L.footer.platforms[i].title}</span>
                <span className="stripe-body stripe-body--xs stripe-text-muted mt-1">{L.footer.platforms[i].sub}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <div className="stripe-section stripe-section--white">
        <div className="stripe-container px-4 text-center">
          <h2 className="stripe-heading stripe-heading--lg mb-3">
            {L.footer.tryHeading}
          </h2>
          <p className="stripe-body stripe-body--lg stripe-text-body mb-6">
            {L.footer.riskFree}
          </p>
          <a
            href={mainUrl("/pricing")}
            className="stripe-btn stripe-btn--primary text-decoration-none d-inline-block px-5 py-3"
            style={{fontSize: '1.05rem', borderRadius: '12px'}}
          >
            {L.footer.getStarted} <i className="fa-solid fa-arrow-right ms-2"></i>
          </a>
        </div>
      </div>

      {/* Footer */}
      <footer className="stripe-bg-dark" style={{paddingTop: '3.5rem', paddingBottom: '2.5rem'}}>
        <div className="stripe-container px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8">
            <div>
              <div className="flex items-center mb-3">
                <img src="/images/logo-icon.png" alt="ViralGPT" className="h-8 w-8 mr-2" style={{filter: 'brightness(0) invert(1)', opacity: 0.9}} />
                <span className="text-white text-xl" style={{fontWeight: 700, letterSpacing: '-0.025em'}}>ViralGPT</span>
              </div>
              <p className="stripe-body stripe-body--sm" style={{color: '#8898aa', maxWidth: '400px', lineHeight: '1.7'}}>
                {L.footer.description}
              </p>
            </div>
            <div className="flex flex-col md:items-end justify-center" style={{gap: '0.75rem'}}>
              <a href={mainUrl("/terms-of-service")} className="text-decoration-none stripe-body stripe-body--sm" style={{color: '#8898aa', transition: 'color 0.2s ease'}}>{L.footer.terms}</a>
              <a href={mainUrl("/privacy-policy")} className="text-decoration-none stripe-body stripe-body--sm" style={{color: '#8898aa', transition: 'color 0.2s ease'}}>{L.footer.privacy}</a>
              <a href={mainUrl("/refund")} className="text-decoration-none stripe-body stripe-body--sm" style={{color: '#8898aa', transition: 'color 0.2s ease'}}>{L.footer.refundPolicy}</a>
            </div>
          </div>
          {/* Compliance disclaimer — no platform affiliation, results not guaranteed */}
          <p className="text-center stripe-body stripe-body--xs mx-auto" style={{color: '#4a5c6e', maxWidth: '720px', lineHeight: 1.6, marginBottom: '1.5rem'}}>
            {L.footer.disclaimer}
          </p>
          <div className="stripe-divider mb-6" style={{background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.1), transparent)'}}></div>
          <div className="text-center stripe-body stripe-body--xs" style={{color: '#596c80'}}>
            &copy; {new Date().getFullYear()} ViralGPT. {L.footer.allRightsReserved}
            <br />
            <span style={{color: '#4a5c6e'}}>30 N Gould St Ste R Sheridan, WY 82801 USA</span>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
